module.exports = __webpack_public_path__ + "img/ford-plaza-layout.290031a8.jpg";